import { Action } from './iamReducer.types'
import { IamStateContextType } from '@percent/partner-dashboard/context/iam/iamContext/IamContext.types'
import { abilityDefinitions } from '@percent/partner-dashboard/context/iam/abilityDefinitions'

export const SET_PERMISSIONS = 'iam/set-permissions'
export const SET_PERMISSIONS_ERROR = 'iam/set-permissions-error'

export const initialState = {
  permissions: [],
  abilityList: abilityDefinitions,
  hasResolvedPermissions: false
}

export const iamReducer: (state: IamStateContextType, action: Action) => IamStateContextType = (state, action) => {
  switch (action.type) {
    case SET_PERMISSIONS:
      return {
        ...initialState,
        ...state,
        ...action.payload,
        hasResolvedPermissions: true
      }
    case SET_PERMISSIONS_ERROR:
      // The fetch settled (unsuccessfully). Mark permissions as resolved so
      // permission-gated UI can fall back to its no-access state instead of
      // waiting indefinitely.
      return {
        ...state,
        hasResolvedPermissions: true
      }
    default: {
      throw new Error(`Unhandled action type: ${(action as Action).type}`)
    }
  }
}
